// extracted by mini-css-extract-plugin
export default {"box":"index_box_vgCou","footer":"index_footer_eCxMD","right_link":"index_right_link_YgZef","f_ico1":"index_f_ico1_NecpA","v_dellink":"index_v_dellink_Jj3FI"};